export namespace GettingFile {
  export enum Type {
    DOCX = 'docx',
    JPG = 'jpg',
    JPEG = 'jpeg',
    ZIP = 'zip',
    XLSX = 'xlsx',
    PDF = 'pdf'
  }

  export enum Slugs {
    // "static" files
    ORDER = 'order',
    REGISTER_REALIZATION = 'register_realization',
    PRODUCT = 'product',
    PRODUCT_LOCAL = 'product_local',
    ORDER_SIDE = 'order_side',
    COMMERCIAL_PROPOSAL_USER = 'commercial_proposal_user',
    COMMERCIAL_PROPOSAL_TEMPLATE = 'commercial_proposal_template',
    PURCHASE_ORDER = 'purchase_order',

    // generating files
    ORDER_SIDE_TEMPLATE = 'order_side_template',
    REPAIR_REPORT = 'repair_report',
    ORDER_REPORT = 'order_report',
    PARTNERSHIP_CERTIFICATE = 'partnership_certificate',
    RESULT_ACTIVE = 'result_active',
    PLAN_FACT = 'plan_fact',
    MONEY_PLAN_FACT = 'money_plan_fact',
    MUTUAL_PAYMENT = 'mutual_payment',
    COMMERCIAL_OFFER = 'commercial_offer',
    SUPPLY_AGREEMENT = 'supply_agreement',
    WARRANTY = 'warranty',
    PRICE_LIST = 'price_list',
    DATA_PILOT_EVENT_LIST = 'data_pilot_event',
    ORDER_PACK = 'order_pack',
    SOFTWARE_LICENSES = 'software_licenses',
  }

  export enum RequestTypes {
    DOCUMENT = 'document',
    IMAGE = 'image'
  }

  export enum BtnsTypes {
    DOWNLOAD = 'download',
    PRINT = 'print',
    PRINT_AND_DOWNLOAD = 'print_and_download',
  }

  export enum Types {
    DOWNLOAD = 'download',
    PRINT = 'print',
  }
}
